<template lang="pug">
v-sheet.py-16.px-2.px-sm-8.px-md-16.d-flex.align-center(color="primary")
  v-container(fluid)
    v-row(justify="center")
      v-col(cols=12 sm=8 md=12)
        v-row(justify="space-around" align="center")
          v-col(v-if="$vuetify.breakpoint.smAndDown" cols=12 md=6)
            v-img(
              src="../../assets/illustrations/erudio_maos_fundo_vermelho.svg"
              alt="Imagem aprendizado na palma da mão"
              transition="scroll-from-right-slow"
              min-height=190
            )
          v-col(cols=12 md=6)
            h3.mb-6.ibm.text-h4.text-md-h3.white--text Aprendizado na palma da mão
            .mb-2.text-body-1.text-md-h6.font-weight-regular.heebo.white--text Ofereça para seus alunos um aplicativo personalizado com sua marca. Acompanhe tudo em tempo real, de onde você estiver.
          v-col(v-if="$vuetify.breakpoint.mdAndUp" cols=12 md=6)
            v-img(
              src="../../assets/illustrations/erudio_maos_fundo_vermelho.svg"
              alt="Imagem aprendizado na palma da mão"
              transition="scroll-from-right-slow"
              min-height=190
            )
</template>

<script>
export default {
  components: {}
}
</script>

<style lang="sass" scoped></style>
